(function () {

  // Header fixed
  var header = document.querySelector('.header');
  if (!header) return;

  var limit = 300;

  function updateHeaderState() {
    var currentScroll = window.pageYOffset || 0;

    if (currentScroll > limit) {
      header.classList.add('is-hidden');
      header.classList.remove('is-active');
    } else {
      header.classList.remove('is-hidden');
      header.classList.add('is-active');
    }
  }

  window.addEventListener('scroll', updateHeaderState);
  updateHeaderState();


  // Menu mobile 
  var body = document.body;
  var toggle = document.getElementById('header-toggle');
  var menu = document.getElementById('mobile-menu');
  var overlay = document.getElementById('mobile-menu-overlay');
  var closeBtn = document.getElementById('mobile-menu-close');

  if (!toggle || !menu || !overlay || !closeBtn) return;

  function openMenu() {
    body.classList.add('is-mobile-menu-open');
    toggle.setAttribute('aria-expanded', 'true');
    menu.setAttribute('aria-hidden', 'false');
  }

  function closeMenu() {
    body.classList.remove('is-mobile-menu-open');
    toggle.setAttribute('aria-expanded', 'false');
    menu.setAttribute('aria-hidden', 'true');
  }

  function toggleMenu() {
    if (body.classList.contains('is-mobile-menu-open')) {
      closeMenu();
    } else {
      openMenu();
    }
  }

  toggle.addEventListener('click', toggleMenu);
  closeBtn.addEventListener('click', closeMenu);
  overlay.addEventListener('click', closeMenu);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeMenu();
    }
  });

  var menuLinks = menu.querySelectorAll('a');
  for (var i = 0; i < menuLinks.length; i++) {
    menuLinks[i].addEventListener('click', function () {
      closeMenu();
    });
  }


  const links = document.querySelectorAll('.menu-item--presupuesto a');
  links.forEach((link) => {
    link.setAttribute('data-fancybox', '');
    link.setAttribute('data-src', '#popup-form-presupuesto');
    link.setAttribute('href', 'javascript:;');
  });

  // submit forms: c-form-*
  var buttons_send_form = document.querySelectorAll('.js-enable-submit');
  if (buttons_send_form.length) {
    setTimeout(function () {
      for (var i = 0; i < buttons_send_form.length; i++) {
        buttons_send_form[i].disabled = false;
      }
    }, 4000);
  }

})();








